import { render } from "./UpdateNode.vue?vue&type=template&id=01833487&scoped=true"
import script from "./UpdateNode.vue?vue&type=script&lang=js"
export * from "./UpdateNode.vue?vue&type=script&lang=js"

import "./UpdateNode.vue?vue&type=style&index=0&id=01833487&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01833487"]])

export default __exports__